import React from 'react';
import {
  Stack,
  Flex,
  Copy,
  Heading,
  SvgCog,
} from '@grubhubprod/gh-cookbook-react';

export const InfoSection: React.FC = () => (
  <Flex flexDirection="column" alignItems="flex-start">
    <Stack
      y="lg"
      width="50px"
      height="50px"
      borderRadius="50%"
      backgroundColor="globals.blue15"
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
      >
        <Copy variant="body" color="interactive">
          <SvgCog size="28px" />
        </Copy>
      </Flex>
    </Stack>
    <Stack y="lg">
      <Heading variant="h2">
        We're Currently Updating Our Self-Signup Process
      </Heading>
    </Stack>
    <Stack y="lg">
      But no need to wait — opening a Corporate account is still quick and easy!
      Our dedicated team is here to get your business set up right away with
      personalized service and support.
    </Stack>
    <Stack y="lg">
      Please fill out a form and a Corporate Accounts specialist will be in
      touch to create your perfect solution.
    </Stack>
  </Flex>
);
